if (!customElements.get('product-form')) {
  customElements.define('product-form', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.root = this.closest('product-info');
      this.cartNotification = document.querySelector('cart-notification');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this), {
        signal: this.controller.signal, capture: this.hasAttribute('data-direct-checkout')
      });
      if (!this.root?.hasAttribute('data-academy-product')) this.form.querySelector('input[name="id"]').disabled = false;
      if (this.hasAttribute('data-direct-checkout')) {
        this.resetDirectCheckout();
        // Discount apps can replace the visible button and intercept its click.
        // Own B2B clicks before those handlers, including the external sticky button.
        this.root?.addEventListener('click', this.onDirectCheckoutClick.bind(this), {
          capture: true, signal: this.controller.signal
        });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.resetDirectCheckout();
        }, { signal: this.controller.signal });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    notify(name, detail) { this.dispatchEvent(new CustomEvent(`product-form:${name}`, { bubbles: true, detail })); }

    onDirectCheckoutClick(event) {
      const button = event.target.closest('button[type="submit"], input[type="submit"]');
      if (!button || button.form !== this.form || button.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.form.requestSubmit(button);
    }

    resetDirectCheckout() {
      this.removeAttribute('aria-busy');
      const variant = Array.from(this.form.elements).find(input => input.name === 'id');
      const unavailable = !variant?.value || variant.disabled || this.root?.dataset.variantAvailable === 'false';
      Array.from(this.form.elements).filter(input => input.type === 'submit').forEach(button => {
        button.disabled = unavailable || !window.BaseballCheckout;
        button.classList.remove('loading');
      });
    }

    submitDirectCheckout(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.hasAttribute('aria-busy') || this.root?.dataset.variantAvailable === 'false') return;
      if (event.submitter?.disabled || !this.form.reportValidity()) return;
      const error = this.querySelector('.product-form__error-message');
      if (error) { error.hidden = true; error.textContent = ''; }
      try {
        const url = window.BaseballCheckout.buildURL(new FormData(this.form), this.dataset.cartUrl, location.origin);
        this.setAttribute('aria-busy', 'true');
        Array.from(this.form.elements).filter(input => input.type === 'submit').forEach(button => {
          button.disabled = true;
          button.classList.add('loading');
        });
        location.assign(url);
      } catch (failure) {
        this.resetDirectCheckout();
        if (error) { error.textContent = this.dataset.checkoutError; error.hidden = false; }
      }
    }

    async onSubmitHandler(event) {
      if (this.hasAttribute('data-direct-checkout')) return this.submitDirectCheckout(event);
      const variantInput = Array.from(this.form.elements).find((input) => input.name === 'id' && !input.disabled && input.value);
      if (this.hasAttribute('aria-busy') || !variantInput?.value) {
        event.preventDefault();
        return;
      }
      if (!this.cartNotification) return;
      event.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);
      const buttons = Array.from(this.form.elements).filter((element) => element.type === 'submit');
      const error = this.querySelector('.product-form__error-message');
      if (error) { error.hidden = true; error.textContent = ''; }
      this.setAttribute('aria-busy', 'true');
      buttons.forEach((button) => { button.disabled = true; button.classList.add('loading'); });
      let detail;
      let added = false;
      try {
        // Native form data preserves properties[...] fields and file uploads,
        // and matches the normal form submission when the cart drawer is absent.
        const formData = new FormData(this.form);
        detail = { variantId: formData.get('id'), quantity: Number(formData.get('quantity') || 1) };
        formData.set('sections', this.cartNotification.getSectionsToRender().map((section) => section.section || section.id).join(','));
        formData.set('sections_url', window.location.pathname);
        const config = fetchConfig('javascript');
        delete config.headers['Content-Type']; // The browser supplies the multipart boundary.
        this.notify('attempt', detail);
        const response = await fetch(routes.cart_add_url, { ...config, body: formData });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || window.cartStrings.error);
        added = true;
        this.notify('success', { ...detail, cart: state });
        this.cartNotification.renderContents(state);
      } catch (failure) {
        if (added) {
          // The item was added; a drawer failure must not invite a duplicate purchase.
          location.assign(this.form.action.replace(/\/cart\/add(?:\.js)?(?:\?.*)?$/, '/cart'));
        } else {
          if (error) { error.textContent = failure.message || window.cartStrings.error; error.hidden = false; }
          if (detail) this.notify('error', { ...detail, message: failure.message });
        }
      } finally {
        this.removeAttribute('aria-busy');
        const invalid = variantInput.disabled || !variantInput.value || this.root?.dataset.academySelectionValid === 'false' || this.root?.dataset.variantAvailable === 'false';
        buttons.forEach((button) => { button.classList.remove('loading'); button.disabled = invalid; });
        this.notify('complete', detail);
      }
    }
  });
}
